import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

export default function AdminFeedback() {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFeedback = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/feedback/');
      setFeedbacks(res.data.feedback || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchFeedback(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/admin/feedback/${id}/`, { status });
      setFeedbacks(prev => prev.map(f => f.id === id ? { ...f, status } : f));
    } catch (err) { alert('Failed to update status'); }
  };

  const deleteFeedback = async (id) => {
    if (!window.confirm('Delete this feedback?')) return;
    try {
      await api.delete(`/admin/feedback/${id}/`);
      setFeedbacks(prev => prev.filter(f => f.id !== id));
    } catch (err) { alert('Failed to delete feedback'); }
  };

  return (
    <div style={{ padding: 24, flex: 1, overflowY: 'auto', background: '#07070d' }}>
      <h2 style={{ color: '#e2e8f0', marginTop: 0, marginBottom: 20 }}>User Feedback</h2>
      
      {loading ? (
        <div style={{ color: '#64748b' }}>Loading...</div>
      ) : feedbacks.length === 0 ? (
        <div style={{ color: '#64748b' }}>No feedback found.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {feedbacks.map(f => (
            <div key={f.id} style={{ background: '#111118', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 12, padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                <div style={{ color: '#94a3b8', fontSize: 12 }}>
                  From <strong style={{ color: '#818cf8' }}>{f.user_username}</strong> on {new Date(f.created_at).toLocaleDateString()} {new Date(f.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </div>
                <select 
                  value={f.status} 
                  onChange={e => updateStatus(f.id, e.target.value)}
                  style={{ background: '#1a1a2e', color: f.status === 'resolved' ? '#4ade80' : f.status === 'dismissed' ? '#94a3b8' : '#fbbf24', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 6, padding: '4px 8px', fontSize: 11, outline: 'none' }}
                >
                  <option value="new">New</option>
                  <option value="reviewed">Reviewed</option>
                  <option value="resolved">Resolved</option>
                  <option value="dismissed">Dismissed</option>
                </select>
              </div>
              <p style={{ margin: '0 0 16px', color: '#e2e8f0', fontSize: 13, lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
                {f.message}
              </p>
              <button style={{ background: 'rgba(239,68,68,0.1)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.2)', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }} onClick={() => deleteFeedback(f.id)}>
                Delete Feedback
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
